import { Container, SourceLabel, ResultLabel } from './styles'

export function DiagnosisBadge ({ tone = 'neutral', source, label, icon }) {
  return (
    <Container tone={tone}>
      {icon && icon}
      {source && <SourceLabel>{source}:</SourceLabel>}
      <ResultLabel>{label}</ResultLabel>
    </Container>
  )
}

export default DiagnosisBadge
